import styled from "styled-components";

export const DeviceHealthContainer = styled.div`
    margin-left: 3.5%;
    padding-bottom: 20px;
`;